module.exports = __webpack_public_path__ + "static/img/ent-detail-62.57ac8b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-62.jpg
// module id = pEdg
// module chunks = 51